import * as SubscriptionActionTypes from './constants';

const initialState = {

  availSubscriptionPlans: [],
 
};

const actionsMap = {
  [SubscriptionActionTypes.SET_SELECTED_SUBSCRIPTION_PLAN](state, { payload }) {
    return {
      ...state,
      availSubscriptionPlans: payload,
    };
  },
  [SubscriptionActionTypes.SET_SHOPPER_SUBSCRIPTION_PLAN](state, { payload }) {
    return {
      ...state,
      availSubscriptionPlans: payload,
    };
  },
  [SubscriptionActionTypes.SET_AVAILABLE_SUBSCRIPTION_PLANS](state, { payload }) {
    return {
      ...state,
      availSubscriptionPlans: payload,
    };
  },
};

export default function items(state = initialState, action) {
  console.log('SUBSCRIPTION ACTION REDUCER initiated')
  console.log(['SUBSCRIPTION function in reducer action: ' , action]);
  console.log(['SUBSCRIPTION reducer about to update state currently: ', state ]);
  const reduceFn = actionsMap[action.type];
  if (!reduceFn) {
    console.log('SUBSCRIPTION ACTION REDUCER did not find ACTION : ', action);
    return state;
  }
  
  console.log("**** SUBSCRIPTION ACTION reducer action : ", action, " AND state", state);
  return reduceFn(state, action);
}

